import React, { useId } from "react";
import { getPrizeAccentColor, getPrizeAccentGradient } from "../../Data/prizeAccents";

const publicUrl = process.env.PUBLIC_URL || "";

/** Place 1–7 → trophy assets in /public/trophies (avoids SVGR on complex SVGs). */
export const PRIZE_TROPHY_BY_PLACE = [
  `${publicUrl}/trophies/36.svg`,
  `${publicUrl}/trophies/37.svg`,
  `${publicUrl}/trophies/38.svg`,
  `${publicUrl}/trophies/39.svg`,
  `${publicUrl}/trophies/40.svg`,
  `${publicUrl}/trophies/41.svg`,
  `${publicUrl}/trophies/42.svg`,
];

/**
 * Place trophy on an accent circle (badge / amount / USD stay on the card).
 * `placeIndex` is 0-based (0 = 1st … 6 = 7th).
 */
const PrizeTrophy = ({ accent, placeIndex = 0 }) => {
  const uid = useId().replace(/:/g, "");
  const gradientId = `prize-trophy-grad-${accent}-${uid}`;
  const { from, to } = getPrizeAccentGradient(accent);
  const trophySrc =
    PRIZE_TROPHY_BY_PLACE[placeIndex] || PRIZE_TROPHY_BY_PLACE[0];

  return (
    <div
      className={`prizes__icon prizes__icon--${accent}`}
      style={{ "--prize-accent": getPrizeAccentColor(accent) }}
      aria-hidden="true"
    >
      <svg
        className="prizes__icon-bg"
        width="152"
        height="152"
        viewBox="0 0 152 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="140"
            y1="0"
            x2="12"
            y2="152"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={from} />
            <stop offset="1" stopColor={to} />
          </linearGradient>
        </defs>
        <circle cx="76" cy="76" r="76" fill={`url(#${gradientId})`} />
      </svg>
      <img
        className="prizes__icon-trophy"
        src={trophySrc}
        alt=""
        width={190}
        height={190}
        decoding="async"
      />
    </div>
  );
};

export default PrizeTrophy;
